let activeMsalInstance = null;

export const setMsalInstance = (instance) => {
  activeMsalInstance = instance;
};

export const getMsalInstance = () => activeMsalInstance;
